<template>
  <section class="pb-8" id="contact">
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-col cols="10">
          <v-row justify="center">
            <v-col cols="12" sm="5">
              <h1 class="font-weight-light display-1">联系我们</h1>
              <h3 class="font-weight-light mt-3">
                

              </h3>
              <h3 class="font-weight-light mt-6">
                保定怎诺智能科技有限公司
              </h3>
              <h3 class="font-weight-light mt-3">
                河北省保定市高开区北二环路5699号大学科技园豆芽创客空间
              </h3>
              <div style="display: flex;">
                  <h3 class="font-weight-light mt-3">
                    联系电话: 
                  </h3>
                  <div style="display: flex;flex-direction: column;">
                    <h3 class="font-weight-light mt-3 ml-3">
                    +86 181 3121 7160 刘先生
                    </h3>
                  <h3 class="font-weight-light ml-3">
                    +86 135 8205 6501 张先生
                  </h3>
                  </div>
              </div>
              <div style="display: flex;">
                <h3 class="font-weight-light">
                  邮政编码:   
                </h3>
                <h3 class="font-weight-light ml-3">
                  071000
                </h3>
              </div>
              
              <div style="display: flex;">
                <h3 class="font-weight-light">
                  E-mail:   
                </h3>
                <h3 class="font-weight-light ml-3">
                  contact@mail.zenow.cn
                </h3>
              </div>
              
            </v-col>
            <v-col cols="12" sm="7">
              <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                <v-text-field
                    v-model="name"
                    :rules="nameRules"
                    label="您的姓名"
                    required
                ></v-text-field>

                <v-text-field
                    v-model="email"
                    :rules="emailRules"
                    label="E-mail"
                    required
                ></v-text-field>

                <v-textarea
                    v-model="textArea"
                    :rules="textAreaRules"
                    label="留言内容"
                    required
                    rows="2"
                />

                <v-btn
                    :disabled="!valid"
                    color="primary"
                    :dark="valid"
                    rounded
                    block
                    class="mt-3"
                    @click="submit"
                >
                  发送留言给我们
                </v-btn>
              </v-form>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <div class="svg-border-waves text-white">
      <v-img src="~@/assets/img/borderWavesBlue.svg"/>
    </div>
    <v-snackbar
        v-model="snackbar.enabled"
        timeout="3000"
        right
        top
        :color="snackbar.color"
    >
      {{ snackbar.text }}

      <template v-slot:action="{ attrs }">
        <v-btn
            text
            v-bind="attrs"
            @click="snackbar.enabled = false"
        >
          Fechar
        </v-btn>
      </template>
    </v-snackbar>
  </section>
</template>

<style scoped>
#contact {
  background-color: #f4f7f5;
}

.svg-border-waves .v-image {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3rem;
  width: 100%;
  overflow: hidden;
}

</style>

<script>
// import {db} from '@/main'

export default {
  data: () => ({
    icons: ["fa-facebook", "fa-twitter", "fa-linkedin", "fa-instagram"],
    valid: true,
    name: "",
    nameRules: [
      (v) => !!v || "请填写您的姓名或称呼",
      (v) => (v && v.length >= 2) || "姓名或称呼过短，请重新输入2字符以上的名称",
    ],
    email: "",
    emailRules: [
      (v) => !!v || "请填写您的联系邮箱",
      (v) => /.+@.+\..+/.test(v) || "邮箱格式不正确，请检查后重新录入",
    ],
    textArea: "",
    textAreaRules: [
      (v) => !!v || "留言内容不能为空",
      (v) => (v && v.length >= 10) || "留言内容过短，请重新输入10字符以上的内容",
    ],
    lazy: false,
    snackbar: {
      enabled: false,
      text: '',
      color: ''
    }
  }),
  methods: {
    submit() {
      /*db.collection("contactData").add({
        name: this.name,
        email: this.email,
        message: this.textArea
      }).then(() => {
        this.snackbar.text = "Mensagem enviada com sucesso"
        this.snackbar.color = "success"
        this.snackbar.enabled = true
      }).catch(() => {
        this.snackbar.text = "Erro ao enviar mensagem"
        this.snackbar.color = "danger"
        this.snackbar.enabled = true
      })*/
    }
  }
};
</script>
